module.exports = {
      id: "arrow-right-usage",
      viewBox: "0 0 448 512",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#arrow-right",
      toString: function () {
        return this.url;
      }
    }